import { AbstractModel } from '@/models/abstractModel';
import { IUserBalanceRowApi } from '@/types/userBalance';

function toNumber(value: number | string | null | undefined): number {
    if (value == null || value === '') return 0;
    const n = typeof value === 'number' ? value : parseFloat(value);
    return Number.isFinite(n) ? n : 0;
}

export class UserBalanceItem extends AbstractModel {
    public balance: number;
    public balanceAgentEuro: number;
    public balanceAgentPc: number;
    public balanceBookmakerEuro: number;
    public balanceBookmakerPc: number;
    public betCount: number;
    public bookFeesEuro: number;
    public bookFeesPerc: number;
    public bookRebateEuro: number;
    public companyComEuro: number;
    public login: string;
    public playerCom: number;
    public playerComEuro: number;
    public playerComPc: number;
    public ptBalance: number;
    public settledBotCount: number;
    public settledStakeAgentSum: number;
    public settledStakeBookmakerSum: number;
    public settledStakeSum: number;
    public toolUserTypeId: number | null;
    public userId: number;

    constructor(data: IUserBalanceRowApi = {}) {
        super();
        this.userId = toNumber(data.ownerId ?? data.user_id ?? data.id);
        this.login = data.login ?? '';
        this.toolUserTypeId = data.tool_user_type_id != null ? toNumber(data.tool_user_type_id) : null;
        this.betCount = toNumber(data.bet_count);
        this.settledBotCount = toNumber(data.settled_bot_count);
        this.settledStakeSum = toNumber(data.settled_stake_sum);
        this.settledStakeAgentSum = toNumber(data.settled_stake_agent_sum);
        this.balance = toNumber(data.balance);
        this.balanceAgentPc = toNumber(data.balance_agent_pc);
        this.playerCom = data.player_com != null && data.player_com !== '' ? toNumber(data.player_com) : toNumber(data.player_com_euro);
        this.playerComPc = toNumber(data.player_com_pc);
        this.playerComEuro = toNumber(data.player_com_euro);
        this.settledStakeBookmakerSum = toNumber(data.settled_stake_bookmaker_sum);
        this.companyComEuro = toNumber(data.company_com_euro);
        this.bookFeesEuro = toNumber(data.book_fees_euro);
        this.bookFeesPerc = toNumber(data.book_fees_perc);
        this.bookRebateEuro = toNumber(data.book_rebate_euro);
        this.balanceBookmakerPc = toNumber(data.balance_bookmaker_pc);
        this.balanceBookmakerEuro = toNumber(data.balance_bookmaker_euro);
        this.balanceAgentEuro = toNumber(data.balance_agent_euro);
        this.ptBalance = toNumber(data.pt_balance);
    }

    get agTotal(): number {
        if (!this.settledStakeSum) return 0;
        return this.balanceAgentPc + this.playerCom;
    }

    get companyPlEuro(): number {
        return this.balanceBookmakerEuro - this.balanceAgentEuro + this.companyComEuro - this.playerComEuro - this.bookFeesEuro + this.bookRebateEuro;
    }
}

export class UserBalanceStats extends UserBalanceItem {}
